import { render, staticRenderFns } from "./UnifiedControlElement.vue?vue&type=template&id=2f5e3afc&lang=pug&"
import script from "./UnifiedControlElement.vue?vue&type=script&lang=js&"
export * from "./UnifiedControlElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports